import { useEffect, useMemo, useState } from "react";
import Draggable from "react-draggable";
import { Box } from "@chakra-ui/layout";
import { COMMON_WEB_PATH, WEB_LAYOUT } from "../../../constant";
import useDeviceType from "../../../hook/useDeviceType";
import { IoIosArrowForward } from "react-icons/io";
import { useTranslation } from "react-i18next";
import useCheckLogin from "../../../hook/useCheckLogin";
import { useNavigate, useParams } from "react-router-dom";
import UseGetGameBoxBackPathV2 from "../../../hook/useGetGameBoxBackPath_v2";
import { useSelector } from "react-redux";
import useIsLandScapeMachine from "../../../hook/useIsLandScapeMachine";
import useOnCloseMessage from "../../../hook/useOnClose";

const PCToolTab = ({ hiddenHeader, setHiddenHeader }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const [dragStartTime, setDragStartTime] = useState(0);
  const { isMachineUser } = useCheckLogin();

  const navigate = useNavigate();
  const getPrevPath = UseGetGameBoxBackPathV2();
  const { to } = useParams();
  const gameConfig = useSelector((state) => state.isGameConfig);
  const { game_platform, gameCode, game_subtype, SubPlatformEnum } =
    gameConfig || {};

  const isLandScapeMachine = useIsLandScapeMachine();

  const handleStart = () => {
    setDragStartTime(Date.now());
  };

  const onClose = () => {
    if (isLandScapeMachine) {
      navigate("/");
    } else if (isMachineUser) {
      navigate(`/${getPrevPath}/category/${SubPlatformEnum || to}/AllGames`);
    } else {
      setHiddenHeader(false);
    }
  };

  useOnCloseMessage(() => {
    onClose();
  });

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      onClose();
    }
  };

  const style = useMemo(() => {
    if (isLandScapeMachine) {
      return {
        // bottom: "0px",
        top: "0px",
      };
    } else {
      return {
        top: "0px",
      };
    }
  }, [isLandScapeMachine]);

  return (
    hiddenHeader && (
      <Draggable onStart={handleStart} onStop={handleStop}>
        <Box
          position={"absolute"}
          bgImage={`url(${COMMON_WEB_PATH}/now888/header/pc_header_bg.png)`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          left={"0px"}
          {...style}
          minW={"48px"}
          h={"52px"}
          rounded={"5px"}
          gap={"10px"}
          alignItems={"center"}
          justifyContent={"center"}
          cursor="pointer"
          className={`!flex`}
          zIndex={999999}
          sx={{
            "& > *": {
              color: "text-yellow-500",
            },
          }}
        >
          {" "}
          {/* <IoIosArrowForward className="text-2xl" /> */}
          {i18n("leave")}
        </Box>
      </Draggable>
    )
  );
};

export default PCToolTab;
